import {Container} from "../core/Container";

export class StorySceneContainer extends Container {
}
